

export const getLanguage = props => props.pageContext.lng
export const getContentTranslation = (content, language) => content[language]
